import { type UseQueryResult, useQuery } from 'react-query';
import {
  RsuAwardService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_RsuAwardListDto,
} from '../../services/wealthlane-award-services';
// import { ParticipantService } from '../../services/wealthlane-customer-services';
import { type TableParamsType } from '../../types/common';

const useGetRsuParticipantList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  filterData: TableParamsType,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_RsuAwardListDto | undefined,
  unknown
> => {
  // const {
  //   approvalStatusId,
  //   optionAcceptance: rsuAcceptance,
  //   fromDate,
  //   toDate,
  //   createdFromDate,
  //   createdToDate,
  //   employeeStatusId,
  //   grantFromDate,
  //   grantToDate,
  // } = filterData;

  const {
    filter,
    sorting,
    skipCount,
    maxResultCount,
    approvalStatusId,
    optionAcceptance: rsuAcceptance,
    fromDate,
    toDate,
    createdFromDate,
    createdToDate,
    employeeStatusId,
    grantFromDate,
    grantToDate,
    _force,
  } = tableInfo;
  const rsuStatus = 0;

  const RsuParticipantList = useQuery(
    [
      'getRsuParticipantList',
      approvalStatusId,
      fromDate,
      toDate,
      employeeStatusId,
      rsuStatus,
      rsuAcceptance,
      createdFromDate,
      createdToDate,
      grantFromDate,
      grantToDate,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        RsuAwardService.getApiAwardApiAppRSUAwardRSUAwardList(
          approvalStatusId ?? [0],
          fromDate,
          toDate,
          employeeStatusId ?? [0],
          rsuStatus,
          rsuAcceptance,
          createdFromDate,
          createdToDate,
          grantFromDate,
          grantToDate,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return RsuParticipantList;
};

export default useGetRsuParticipantList;
